// src/pages/business/Customers/details/index.jsx
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import CommunicationPanel from './CommunicationPanel'
import CustomerDetailsCard from './CustomerDetails'
import CustomerInvoices from './CustomerInvoices'
import CustomerBookings from './CustomerBookings'
import CustomerMemberships from './CustomerMemberships'

import CustomerService from '@/services/CustomerService'

import DependentCollectionList from '@/pages/system/SingleCustomCollection/details//DependentCollectionList'

const LOAD_FAILED_KEY = 'customers.details.messages.loadFailed'

export default function CustomerDetails() {
	const { t } = useTranslation()
	const { id } = useParams();
	const [customerDetails, setCustomerDetails] = useState(null);
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)

	useEffect(() => {
		if (!id) {
			setCustomerDetails(null)
			setError(null)
			setLoading(false)
			return
		}

		let alive = true
		setLoading(true)
		setError(null)

			; (async () => {
				try {
					const { data, error: fetchError } = await CustomerService.getCustomerById(id)
					if (!alive) return
					if (fetchError) {
						setError(fetchError)
						setCustomerDetails(null)
					} else {
						setCustomerDetails(data)
					}
				} catch (err) {
					if (!alive) return
					setError(err.message || LOAD_FAILED_KEY)
					setCustomerDetails(null)
				} finally {
					if (alive) setLoading(false)
				}
			})()

		return () => {
			alive = false
		}
	}, [id])

	if (loading) {
		return <div className="min-h-screen flex items-center justify-center">{t('customers.details.loading')}</div>
	}

	if (error) {
		return <div className="min-h-screen flex items-center justify-center text-red-600">{t(error, { defaultValue: error })}</div>
	}


	if (!id) {
		return <div className="min-h-screen flex items-center justify-center">{t('customers.details.noCustomerSelected')}</div>
	}

	return (
		<div>
			<ul role="list" className="grid grid-cols-1 gap-6 xl:grid-cols-2">
				{/* Profile card */}
				<CustomerDetailsCard customerId={id} customerDetails={customerDetails} />

				{/* Communication panel */}
				<CommunicationPanel customerId={id} />
			</ul>

			<ul role="list" className="grid grid-cols-1 gap-6 xl:grid-cols-1 mt-6">
				{/* Invoices list */}
				<CustomerInvoices customerId={id} title={t('customers.details.invoices.title')} />
			</ul>

			{/* <ul role="list" className="grid grid-cols-1 gap-6 xl:grid-cols-2 mt-6">
				<CustomerBookings customerId={id} title={t('customers.details.bookings.title')} />
				<CustomerMemberships customerId={id} title={t('customers.details.memberships.title')} />
			</ul> */}

			<ul role="list" className="grid grid-cols-1 gap-6 xl:grid-cols-1">
				{/* Dependent collections */}
				<DependentCollectionList parentCollectionDetails={{ _id: "Customers", name: "Customers" }} item={customerDetails} addNewReturnPath={`/system/customers/details/${id}`} />
			</ul>
		</div>
	)
}
